import {
  getBaseState,
  getEntityAdapterReducers,
  handleFulfilledAction,
  handleMultipleLoadingActions,
} from '@hwm/ui-lib/core/store';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { SelectedSitesListModel, SiteSummaryModel } from '@shared/models';
import { EntityReducers } from '../../EntityReducer';
import { thunks } from './SitesThunks';

const entityAdapter = createEntityAdapter({
  selectId: (entity: SiteSummaryModel) => entity.id,
});

const slice = createSlice({
  name: EntityReducers.sites,
  initialState: {
    ...getBaseState(entityAdapter, {
      totalAll: null as number,
      totalSelected: null as number,
      mainUserTotalSelected: null as number,
      selectedSitesList: null as SelectedSitesListModel,
    }),
  },
  reducers: {
    ...getEntityAdapterReducers(entityAdapter),
    setAllAndSelectedEmpty: (state) => {
      state.totalAll = null;
      state.totalSelected = null;
    },
    setUserSelectedEmpty: (state) => {
      state.mainUserTotalSelected = null;
    },
    setSelectedSitesList: (state, { payload }: { payload: SelectedSitesListModel }) => {
      state.selectedSitesList = payload;
    },
  },
  extraReducers: (builder) => {
    handleMultipleLoadingActions(
      [thunks.getSiteList, thunks.getSelectedSiteList, thunks.handleFavorites, thunks.uploadPhotos],
      builder
    );
    handleFulfilledAction(thunks.getSiteList, builder, (state, payload) => {
      entityAdapter.upsertMany(state, payload.items);
      state.totalAll = payload.itemsTotal;
    });
    handleFulfilledAction(thunks.getSelectedSiteList, builder, (state, payload) => {
      entityAdapter.upsertMany(state, payload.items);
      if (state.totalSelected === null && state.mainUserTotalSelected === null) {
        state.mainUserTotalSelected = payload.itemsTotal;
      }
      state.totalSelected = payload.itemsTotal;
    });
    handleFulfilledAction(thunks.handleFavorites, builder, (state, payload) => {
      entityAdapter.updateOne(state, {
        id: payload.siteId,
        changes: { isSelected: payload.add },
      });
      const total = state.mainUserTotalSelected;
      state.mainUserTotalSelected = Math.max(0, payload.add ? total + 1 : total - 1);
    });
    handleFulfilledAction(thunks.uploadPhotos, builder, () => {});
  },
});

export const siteReducer = {
  slice,
  entityAdapter,
  thunks,
};
